import PieChartPrint from './pieChartPrint.js';
export default PieChartPrint;
